import { Overlay } from '@angular/cdk/overlay';
import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from '../../../services/route-planning/route-planning.service';
import { DATA_INJECTION_TOKEN } from 'src/app/@shared/services/overlay/overlay.service';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrl: './map.component.scss',
    standalone: false
})
export class MapComponent extends CardDesignComponent {
    @ViewChild('map') mapDiv?: ElementRef;
    
    @Output() onMapClose = new EventEmitter<any>();

    @Input() mapInitialized: boolean = false;
    @Input() hasErrorLoadingMap: boolean = false;
    @Input() isCard: boolean = false;

    constructor(
        routePlanningService: RoutePlanningService,
        resizeService: ResizeService,
        overlay: Overlay,

        @Inject(DATA_INJECTION_TOKEN)
        public readonly data: {
            title: string
        },

    ) {
        super(routePlanningService, resizeService, overlay);
    }
}